import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../components/api";
import { formatDateTime } from "../../utils/dateFormat";
import "bootstrap/dist/css/bootstrap.min.css";
import AuthContext from "../context/AuthContext";
import RequestHistory from "./requestsHistory";
import Modal from "react-bootstrap/Modal";
import axios from "axios";

const Requests = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processingRequestId, setProcessingRequestId] =
    useState(null);
  const [requestError, setRequestError] = useState("");

  const { user } = useContext(AuthContext);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));
  const [searchQuery, setSearchQuery] = useState("");
  const [showHistory, setShowHistory] = useState(false);
  const handleshowHistory = () => setShowHistory(true);
  const handleCloseHistory = () => setShowHistory(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const authTokens = JSON.parse(localStorage.getItem("authTokens"));
      const response = await axios.get(`${API_URL}/inventory/requests/`, {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
        params: {
          username: user.username,
          action: "Pending",
        },
      });

      if (response.status === 200) {
        setData(response.data);
        console.log(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [user.username]);

  useEffect(() => {
    // Save "searchValue" value before clearing other session storage items
    const searchValue = sessionStorage.getItem("searchRequest");
  
    // Clear all session storage items except "searchValue"
    Object.keys(sessionStorage).forEach((key) => {
      if (key !== "searchRequest") {
        sessionStorage.removeItem(key);
      }
    });
  
    // Restore "searchValue" value if needed
    if (searchValue) {
      sessionStorage.setItem("searchRequest", searchValue);
      setSearchQuery(searchValue)
    }
  }, []);
  
  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    sessionStorage.setItem("searchRequest", query);
  };

  const filteredData = data.filter((row) => {
    const searchWords = searchQuery.split(" ");
    return searchWords.every((word) =>
      Object.values(row).some((value) =>
        String(value).toLowerCase().includes(word.toLowerCase().trim())
      )
    );
  });

  const handleRequestAction = async (id, action) => {
    if (processingRequestId !== null) {
      return;
    }

    setProcessingRequestId(id);
    setRequestError("");

    try {
      await axios.post(
        `${API_URL}/inventory/requests/`,
        {
          Action: action,
          request_id: id,
          userdealer: user.username,
        },
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        }
      );

      setData((current) =>
        current.filter(
          (item) => item.request_id !== id
        )
      );
      await fetchData();
    } catch (error) {
      setRequestError(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "The request could not be processed."
      );
    } finally {
      setProcessingRequestId(null);
    }
  };

  const formatDate = (dateString) => formatDateTime(dateString);

  return (
    <div
      className="container mt-5"
      style={{
        overflow: "auto",
        height: "80vh",
      }}
    >
      <div className="mb-4 d-flex">
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearch}
          className="form-control"
        />
        <button className="add-button" onClick={handleshowHistory}>
          History
        </button>
      </div>
      {requestError && (
        <div className="alert alert-danger">
          {requestError}
        </div>
      )}
      {!loading && filteredData.length > 0 && (
        <div className="row">
          {filteredData.map((item) => (
            <div className="col-12 mb-4" key={item.request_id}>
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">
                    <b>Initiator: </b>
                    {item.initiator}
                  </h5>
                  <h5 className="card-title">
                    <b>Date: </b>
                    {formatDate(item.date)}
                  </h5>

                  <p className="card-text">{item.description}</p>
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-success"
                      onClick={() =>
                        handleRequestAction(
                          item.request_id,
                          "Accept"
                        )
                      }
                      disabled={processingRequestId !== null}
                    >
                      {processingRequestId === item.request_id
                        ? "Processing..."
                        : "Accept"}
                    </button>
                    <button
                      className="btn btn-danger"
                      onClick={() =>
                        handleRequestAction(
                          item.request_id,
                          "Refuse"
                        )
                      }
                      disabled={processingRequestId !== null}
                    >
                      {processingRequestId === item.request_id
                        ? "Processing..."
                        : "Refuse"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
          
        </div>
      )}
      <Modal
            show={showHistory}
            onHide={handleCloseHistory}
            className="modal-lg request-history-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>Request History</Modal.Title>
            </Modal.Header>
            <div className="request-history-modal-body">
              <RequestHistory />
            </div>
          </Modal>
    </div>
  );
};

export default Requests;
